// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1809d114","239":"2e94d72d","453":"6d2fb3a6","455":"2d92cf17"}[chunkId] + ".chunk.js";
};